import * as React from 'react';
import { useForm } from 'react-hook-form';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Fieldset from 'src/components/project-billing/components/FieldSetComponent';
import { IArPastDueSearchCriteria } from '../AccountsReceivableServiceContext';

interface IArPastDueSearchProps {
    runQuery: (criteria: IArPastDueSearchCriteria) => void;
}

// Mirrors ar_pastdue.fmt's INVOICE_TYPE poplist (element list oid 34/35: "Expense Invoices"=1,
// "Lease Invoices"=2). "All" isn't a real Oracle list entry, but the Query trigger's own
// `if invoice_type = 3` branch treats 3 as both types, so it's exposed here as a real option.
const INVOICE_TYPE_OPTIONS = [
    { value: '3', label: 'All' },
    { value: '1', label: 'Expense Invoices' },
    { value: '2', label: 'Lease Invoices' },
];

// Mirrors ar_pastdue.fmt's PAST_DUE poplist (element list oid 38-41). Oracle has no "All" entry
// here either - an unselected value just skips the age filter, same as the empty option below.
const PAST_DUE_OPTIONS = [
    { value: '', label: 'All' },
    { value: '45+', label: '45+ Days' },
    { value: '60+', label: '60+ Days' },
    { value: '90+', label: '90+ Days' },
    { value: '120+', label: '120+ Days' },
];

// Mirrors the Control block's search fields (Invoice Type, Past Due, Client No., Prospect No.)
// and its Query button (WHEN-BUTTON-PRESSED oid 44).
const ArPastDueSearch = (props: IArPastDueSearchProps) => {
    const { register, errors, getValues } = useForm();

    const toNumber = (numStr: string) => (!!numStr && !isNaN(Number(numStr)) ? Number(numStr) : undefined);

    const executeSearch = () => {
        const values = getValues();
        const criteria: IArPastDueSearchCriteria = {
            clientNumber: toNumber(values.clientNumber),
            projectNumber: toNumber(values.projectNumber),
            invoiceType: values.invoiceType || '3',
            pastDue: values.pastDue || undefined,
        };
        props.runQuery(criteria);
    };

    return (
        <Page style={{ justifyContent: 'center' }}>
            <Page.Section width={12}>
                <Panel backgroundColor="#D3D3D3">
                    <Panel panelTitle="A/R Past Due Search">
                        <form>
                            <div className="form-row" style={{ padding: '.5rem', margin: '0', flexWrap: 'nowrap', alignItems: 'flex-end' }}>
                                <div style={{ width: '20%' }}>
                                    <Fieldset label="Invoice Type" style={{ border: 0, padding: 0 }}>
                                        <RHFSelect
                                            name="invoiceType"
                                            options={INVOICE_TYPE_OPTIONS}
                                            defaultVal="3"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                        />
                                    </Fieldset>
                                </div>
                                <div style={{ width: '18%', paddingLeft: '4px' }}>
                                    <Fieldset label="Past Due" style={{ border: 0, padding: 0 }}>
                                        <RHFSelect
                                            name="pastDue"
                                            options={PAST_DUE_OPTIONS}
                                            defaultVal=""
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                        />
                                    </Fieldset>
                                </div>
                                <div style={{ width: '14%', paddingLeft: '4px' }}>
                                    <Fieldset label="Client No." style={{ border: 0, padding: 0 }}>
                                        <RHFInputBox name="clientNumber" type="number" register={register} errors={errors} style={{ width: '100%' }} bodyStyle={{ width: '100%' }} />
                                    </Fieldset>
                                </div>
                                <div style={{ width: '14%', paddingLeft: '4px' }}>
                                    <Fieldset label="Prospect No." style={{ border: 0, padding: 0 }}>
                                        <RHFInputBox name="projectNumber" type="number" register={register} errors={errors} style={{ width: '100%' }} bodyStyle={{ width: '100%' }} />
                                    </Fieldset>
                                </div>
                                <div style={{ display: 'flex', marginLeft: 'auto', flexShrink: 0, paddingLeft: '1rem' }}>
                                    <Button
                                        text="Query"
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', width: '7rem', height: '3rem', verticalAlign: 'middle', marginLeft: '1rem', borderRadius: '5px' }}
                                        onClick={() => executeSearch()}
                                    />
                                </div>
                            </div>
                        </form>
                    </Panel>
                </Panel>
            </Page.Section>
        </Page>
    );
};

export default ArPastDueSearch;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/components/ArPastDueSearch.tsx